import React, { useEffect, useState } from "react";
import {Link} from 'react-router-dom';
import './navbar.css';
import Logo from '../../images/SRI.png'
import SweetAlert from "react-bootstrap-sweetalert";
import api from "../../services/api";
import { vhostV1 } from "../funcoes";
import {
  AppBar, Toolbar, Typography, IconButton, Menu, MenuItem, Button, Box
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';

function Navbar(){

  const [clickVersao, setClickVersao] = useState(false);
  const [msgVersao, setMsgVersao] = useState('');
  const validarNavbar = {
    produto: true,
    grupo:true,
    estoque: true,
    cadastro: true,
    pedidos: true,
    nfe: true,
    financeiro: true,
    gerencial: true
  }
  

  
 const versao = `1.0.2`;
 const Data = '17/06/2025';

    function logout(){
       localStorage.removeItem('token');
       localStorage.removeItem('colaborador');
       document.location = '/';
    }

   
    


    function botaoVersao(){
      {setMsgVersao(versao);
        setClickVersao(true)
      }
    }


     const [anchorEl, setAnchorEl] = useState(null);
  const [menuOpen, setMenuOpen] = useState(null);

  const handleMenu = (event, menu) => {
    setMenuOpen(menu);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setMenuOpen(null);
  };

  const menuDropdown = (label, items) => (
    <>
      <Button
        color="inherit"
        onClick={(e) => handleMenu(e, label)}
        sx={{ fontSize: '13px' }}
      >
        {label}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={menuOpen === label}
        onClose={handleClose}
      >
        {items.map(({ label, href, onClick }) => (
          <MenuItem
            key={label}
            onClick={() => {
              handleClose();
              if (onClick) onClick();
            }}
            component={href ? 'a' : 'div'}
            href={href}
            sx={{ fontSize: '13px' }}
          >
            {label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );


   


   return (
    <AppBar position="fixed"  sx={{ backgroundColor: '#333333' }}>
      <Toolbar sx={{ fontSize: '13px' }}>

        {/* <IconButton edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }}>
          <MenuIcon />
        </IconButton> */}

        <Box component={Link} to="/app/home" sx={{ display: 'flex', alignItems: 'center', textDecoration: 'none',
        color: 'inherit',
        fontSize: '13px' }}>
          <img src={Logo} alt="Logo" height="28" />
        </Box>

        <Box sx={{ flexGrow: 1, display: 'flex', ml: 3 }}>
          <Button color="inherit" component={Link} sx={{ fontSize: '13px' }} to="/app/home">Home</Button>

          {validarNavbar?.produto && menuDropdown('Produtos', [
            { label: 'Produto', href: '/app/produto' },
            { label: 'Classificação Mercadológica', href: '/app/grupo' },
            // { label: 'SubGrupos', href: '/app/subgrupo' },
            // { label: 'Linhas', href: '/app/linha' },
            { label: 'Ficha técnica', href: '/app/fichaTecnica' },
          ])}

          {validarNavbar?.estoque && menuDropdown('Estoque', [
            { label: 'Ajuste de Estoque', href: '/app/estoque/entrada' },
            { label: 'Visualização de Estoques', href: '/app/estoque/prodEstoque' },
            { label: 'Compra', href: '/app/estoque/compra' },
          ])}

          {validarNavbar?.cadastro && menuDropdown('Cadastros', [
            { label: 'Cliente', href: '/app/cadastro/C' },
            { label: 'Fornecedor', href: '/app/cadastro/F' },
            { label: 'Colaborador', href: '/app/colaborador' },
            { label: 'Mesas', href: '/app/cadastroMesa' }
            // { label: 'Entregador', href: '/app/cadastroMotoqueiro' }
          ])}

          {validarNavbar?.pedidos && menuDropdown('Pedidos', [
            { label: 'Venda', href: '/app/listapedidos' },
            // { label: 'Delivery', href: '/app/pedido/delivery' },
            { label: 'Vendas - Dashboard', href: '/app/pedidosDashboard' },
          ])}

          {validarNavbar?.nfe && menuDropdown('Nfe', [
            { label: 'NFe', href: '/app/nfe' },
            { label: 'NCM', href: '/app/ncm' },
          ])}

          {validarNavbar?.financeiro && menuDropdown('Financeiro', [
            { label: 'Banco', href: '/app/banco' },
            { label: 'Contas', href: '/app/contas' },
            { label: 'Tesouraria', href: '/app/tesouraria' },
            { label: 'Finalizadora', href: '/app/finalizadora' },
            // { label: 'D.R.E - Dashboard', href: '/app/dreDashboard' },
          ])}

          {validarNavbar?.gerencial && menuDropdown('Gerencial', [
            { label: 'Empresa', href: '/app/empresa' },
            { label: 'Configurações', href: '/app/configGerencial' },
            { label: 'Versão', onClick: () => setClickVersao(true) },
          ])}

        </Box>

        <Button sx={{ fontSize: '13px' }} color="inherit" onClick={logout}>Sair</Button>

        <Typography sx={{ ml: 2 }}>
          <AccountCircle /> {localStorage.getItem("usuario").toLocaleUpperCase()}
        </Typography>
      </Toolbar>


      {/* ALERTA */}
      {clickVersao && (
                  <SweetAlert
                      info
                      confirmBtnText="OK"
                      confirmBtnBsStyle="info"
                      title={`Versão: ${versao}`}
                      onConfirm={() => setClickVersao(false)}
                  >
                      {Data}
                  </SweetAlert>
              )}
    </AppBar>
   
  
  );
  }


export default Navbar;